import { FlipCardType, FlipCardWidgetHelper, } from '../content/contentBuilder/widgets/FlipCard';
import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { ContentFragmentType } from '../content/contentBuilder/Content';
export const convertFlipCardWidgetToServerModel = (widget) => {
    const assetIds = [];
    const frontData = [];
    const frontTypes = [];
    const backData = [];
    const backTypes = [];
    for (const card of widget.value.data.cards) {
        frontTypes.push(card.front.type);
        if (card.front.type === FlipCardType.imageFull) {
            assetIds.push(card.front.assetId);
            frontData.push(card.front.assetId);
        }
        if (card.front.type === FlipCardType.text) {
            frontData.push(card.front.text);
        }
        backTypes.push(card.back.type);
        if (card.back.type === FlipCardType.imageFull) {
            assetIds.push(card.back.assetId);
            backData.push(card.back.assetId);
        }
        if (card.back.type === FlipCardType.text) {
            backData.push(card.back.text);
        }
    }
    return {
        id: widget._id,
        trackingIdentifier: widget.trackingIdentifier,
        type: WidgetType.flipCard,
        data: {
            assets: assetIds.filter((value, index, array) => array.indexOf(value) === index),
            frontData,
            frontTypes,
            backData,
            backTypes,
        },
        properties: {
            displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
            isRequired: widget.value.properties.isRequired,
        },
    };
};
export const convertFlipCardWidgetFromServerModel = (serverModel) => {
    var _a;
    const numberOfCards = Math.max(serverModel.data.frontTypes.length, serverModel.data.frontData.length, serverModel.data.backTypes.length, serverModel.data.backData.length);
    if (!(serverModel.data.frontTypes.length === numberOfCards &&
        serverModel.data.frontData.length === numberOfCards &&
        serverModel.data.backTypes.length === numberOfCards &&
        serverModel.data.backData.length === numberOfCards)) {
        console.warn('Not all card array are same, values will be populated with default card');
    }
    const cards = [];
    for (let i = 0; i < numberOfCards; ++i) {
        const frontFace = createCardFace(FlipCardType[serverModel.data.frontTypes[i]], serverModel.data.frontData[i], FlipCardWidgetHelper.createBasicFlipCard().front);
        const backFace = createCardFace(FlipCardType[serverModel.data.backTypes[i]], serverModel.data.backData[i], FlipCardWidgetHelper.createBasicFlipCard().back);
        const slide = {
            front: frontFace,
            back: backFace,
        };
        cards.push(slide);
    }
    return {
        _id: serverModel.id,
        type: ContentFragmentType.Widget,
        initialized: true,
        trackingIdentifier: serverModel.trackingIdentifier,
        value: {
            type: WidgetType.flipCard,
            data: {
                cards: cards,
            },
            properties: {
                displayDelayInSeconds: serverModel.properties.displayDelayInSeconds,
                roundCorners: serverModel.properties.roundCorners,
                isRequired: (_a = serverModel.properties.isRequired) !== null && _a !== void 0 ? _a : false,
            },
        },
    };
};
const createCardFace = (type, data, defaultFace) => {
    if (data === undefined || type === undefined) {
        return defaultFace;
    }
    if (type === FlipCardType.text) {
        return {
            type: FlipCardType.text,
            text: data,
        };
    }
    if (type === FlipCardType.imageFull) {
        return {
            type: FlipCardType.imageFull,
            assetId: data,
        };
    }
    return defaultFace;
};
